import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
//import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import { connect } from 'react-redux';

import WelcomeRemark from "components/hero/TwoColumnWithFeaturesAndTestimonial.js";
import Header from "components/Navbar";
import Footer from "components/footers/FiveColumnDark.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";

//const Subheading = tw.span`uppercase tracking-wider text-sm`;
const AUComponent = (props) => {  

  const data = props.aboutUsData;

  return (
    <AnimationRevealPage>
      <Header />
      {Object.keys(data.MainFeatures.MainFeaturesOtherData).map((mf, i) => (<MainFeature1 key={i} dataToRender={data.MainFeatures} componentIndex={i} />))}      
      <Features />
      <WelcomeRemark />
      {/* <TeamCardGrid /> */}
      <Footer />
    </AnimationRevealPage>
  );
};

const AboutUs = connect((state) => ({
  aboutUsData: state.AboutUsData
}))(AUComponent);

export default AboutUs;